module.exports = __webpack_public_path__ + "static/media/menu.623ffa7e.png";